const internationalizationErrorPrefix = 'idVerification.captureDevice.error.';
const internationalizationPrefix = 'idVerification.captureDevice.';
const internationalizationRequestWentWrongKey = 'idVerification.error.requestWentWrong';

/**
 * Because identity verification APIs routinely trigger a calculation with
 * Amazon's machine learning models, which typically takes several seconds, a
 * request typically requires 5 seconds of server-side analysis before it can
 * provide a response.
 *
 * I leave an additional 15 seconds for the delay due to the network and the
 * variance between the computation times according to the time of day.
 */
const idverificationApiTimeout = 20000;

const IdVerificationStatus = {
    VERIFIED: 'verified',
    REJECTED: 'rejected',
    NOT_SET: 'not_set',
    NEED_FOLLOW_UP: 'requires_follow_up',
    REQUIRES_PHOTO_RETAKE: 'requires_photo_retake',
};

export {
    idverificationApiTimeout,
    internationalizationErrorPrefix,
    internationalizationPrefix,
    internationalizationRequestWentWrongKey,
    IdVerificationStatus,
};
